import { render } from "./CoBrandBlueprint.vue?vue&type=template&id=873ad0bc&scoped=true"
import script from "./CoBrandBlueprint.vue?vue&type=script&lang=js"
export * from "./CoBrandBlueprint.vue?vue&type=script&lang=js"

import "./CoBrandBlueprint.vue?vue&type=style&index=0&id=873ad0bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873ad0bc"]])

export default __exports__